import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { appPaths, queryKeys } from '~/routes/app-paths';
import {
  createInsightMessage,
  CreateInsightMessageProps,
} from '~/services/create-insight-message/createInsightMessage';

import { useTerminalNavigate } from '../use-terminal-navigate/useTerminalNavigate';

export const useNavigateToInsight = () => {
  const location = useLocation();
  const navigateTerminal = useTerminalNavigate();
  const { t } = useTranslation(['common']);

  const goToInsight = ({
    insightId,
    title,
    name,
  }: CreateInsightMessageProps) => {
    if (location.pathname === appPaths.alfred) {
      createInsightMessage({
        insightId,
        title,
        name,
      });
    } else {
      const searchParams = new URLSearchParams();
      searchParams.append(queryKeys.insightId, insightId);

      if (title) {
        searchParams.append(queryKeys.insightTitle, title);
      }

      if (name) {
        searchParams.append(queryKeys.insightName, name);
      }

      navigateTerminal({
        to: {
          pathname: appPaths.alfred,
          search: searchParams.toString(),
        },
        crumb: {
          label: t('common:sideNavigation.alfred'),
          isAccessibleFromSideBar: true,
        },
      });
    }
  };

  return goToInsight;
};
